// extracted by mini-css-extract-plugin
export default {"newDeposit":"NewDeposit_newDeposit__P8cPt","container":"NewDeposit_container__4k5We"};